import { normalizeGlobalRole } from "../constants/adminRbac";

export const isAdmin = (user) => {
  if (!user) return false;

  if (user.roles && Array.isArray(user.roles)) {
    return user.roles.some(
      (role) =>
        role.role_type === "admin" ||
        role.role_type === "super_admin" ||
        role.role?.role_type === "admin" ||
        role.role?.role_type === "super_admin"
    );
  }

  return ["admin", "super_admin"].includes(normalizeGlobalRole(user.role));
};

export const isSuperAdmin = (user) => {
  if (!user) return false;

  if (user.roles && Array.isArray(user.roles)) {
    return user.roles.some(
      (role) =>
        role.role_type === "super_admin" ||
        role.role?.role_type === "super_admin"
    );
  }

  return normalizeGlobalRole(user.role) === "super_admin";
};
